"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.TextWrapper = exports.IconWrapper = exports.DateWrapper = void 0;
var _base = _interopRequireDefault(require("@emotion/styled/base"));
var _react = require("@emotion/react");
var _breakpoints = _interopRequireDefault(require("../../../globals/styles/breakpoints"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
const Wrapper = exports.Wrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1gdadix3"
} : {
  target: "e1gdadix3",
  label: "Wrapper"
})(props => /*#__PURE__*/(0, _react.css)("display:grid;grid-template-columns:75px 45px 1fr;grid-column-gap:1em;position:relative;&:after{content:'';position:absolute;width:1px;background-color:", props.theme.border, ";top:5px;bottom:calc(-1em - 5px);left:calc(75px + 1em + (45px / 2));}@media screen and (max-width: ", _breakpoints.default.medium, "){grid-template-columns:65px 40px 1fr;grid-column-gap:0.5em;&:after{left:calc(65px + 0.5em + (40px / 2));}}" + (process.env.NODE_ENV === "production" ? "" : ";label:Wrapper;")));
const DateWrapper = exports.DateWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1gdadix2"
} : {
  target: "e1gdadix2",
  label: "DateWrapper"
})(process.env.NODE_ENV === "production" ? {
  name: "84ppmq",
  styles: "display:grid;text-align:right;height:min-content"
} : {
  name: "84ppmq",
  styles: "display:grid;text-align:right;height:min-content",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
const IconWrapper = exports.IconWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1gdadix1"
} : {
  target: "e1gdadix1",
  label: "IconWrapper"
})("display:flex;justify-content:center;align-items:center;width:45px;height:45px;border-radius:50%;box-shadow:0 2px 4px 0 rgba(0, 0, 0, 0.1);background-color:#ffffff;z-index:1;@media screen and (max-width: ", _breakpoints.default.medium, "){width:40px;height:40px;}");
const TextWrapper = exports.TextWrapper = /*#__PURE__*/(0, _base.default)("div", process.env.NODE_ENV === "production" ? {
  target: "e1gdadix0"
} : {
  target: "e1gdadix0",
  label: "TextWrapper"
})("display:grid;grid-row-gap:0.5em;box-shadow:0 2px 4px 0 rgba(0, 0, 0, 0.1);border-radius:4px;padding:1.5em;word-break:break-word;@media screen and (max-width: ", _breakpoints.default.medium, "){padding:1em;}");